import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  ThreadsShareButton,
  ThreadsIcon,
} from "react-share";

import Cross from "../assets/images/svgs/cross.svg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { persistor } from "../redux/store";
import { signout } from "../redux/slices/auth/signoutSlice";
import { toast } from "react-toastify";
import { deleteCookies } from "../helper/utils";

import Logo from "../assets/images/logo-small.png";
import Twitter from "../assets/images/svgs/twitter 1.svg";

export const Modal = ({ open, setOpen }) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(true);
  const configData = useSelector((state) => state.config.data);

  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-content-bg">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            {/* <span className=" text-light-purple fs-24 text-center">
              {t(`Mission.missionAchieved`)}
            </span> */}

            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
            />
            {/* <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span
                className="svg-icon svg-icon-1"
                onClick={() => {
                  setOpen(!open);
                }}
              >
                <img src={Cross} className="svg-icon" />
              </span>
            </div> */}
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span className="my-2 fs-20">{t(`Mission.subText`)}</span>
            {/* <br /><br /> */}
            <span
              className="box-purple py-2 px-4 align-self-center cursor-pointer m-2"
              onClick={() => {
                setOpen(!open);
              }}
            >
              {t("Mission.ok")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const LocationBlockedModal = ({ open, onClick, message }) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(true);
  const configData = useSelector((state) => state.config.data);
  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-content-bg">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
            />
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span className="my-2 fs-20">{message}</span>
            {/* <br /><br /> */}
            <span
              className="box-purple py-2 px-4 align-self-center cursor-pointer m-2"
              onClick={onClick}
            >
              {t('Mission.ok')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const LocationAllowModal = ({ open, onRetry }) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(true);
  const configData = useSelector((state) => state.config.data);
  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-content-bg">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
            />

            {/* <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span
                className="svg-icon svg-icon-1"
                onClick={() => {
                  setOpen(!open);
                }}
              >
                <img src={Cross} className="svg-icon" />
              </span>
            </div> */}
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span className="my-2 fs-20">{t(`Location.enableLocation`)}</span>
            {/* <br /><br /> */}
            <span
              className="box-purple py-2 px-4 align-self-center cursor-pointer m-2"
              onClick={onRetry}
            >
              {t("Location.retry")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const LogoutModal = ({ open, setOpen }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const configData = useSelector((state) => state.config.data);
  const handleLogout = () => {
    dispatch(signout())
      .unwrap()
      .then((res) => {
        if (res.status) {
          toast.success(res.message);
        }
        deleteCookies("xcasino_token");
        dispatch({ type: "RESET_STATE" });
        setOpen(false);

        persistor.purge();

        sessionStorage.clear();
        localStorage.clear();

        navigate("/");
      })
      .catch((error) => {
        // toast.error(error.message);
        console.error("Failed to fetch user:", error);
      });
  };

  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-content-bg h-100">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
            />
            {/* <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span
                className="svg-icon svg-icon-1"
                onClick={() => {
                  setOpen(!open);
                }}
              >
                <img src={Cross} className="svg-icon" />
              </span>
            </div> */}
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span className="my-2 fs-20">{t(`Sidebar.logoutSubText`)}</span>
            {/* <br /><br /> */}
            <div className="d-flex flex-wrap justify-content-center mt-2 mt-md-3 mt-lg-4 mt-xl-4 mb-2">
              <button
                type="submit"
                className={`
             btn-red btn-red-shadow px-3 px-md-5 py-2 mx-2 btn fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                  handleLogout();
                }}
              >
                <span className="text-white-btn my-0">{t("Common.yes")}</span>
              </button>
              <button
                type="submit"
                className={`
             btn-purple btn-purple-shadow px-3 px-md-5 py-2 btn mx-2 fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                  setOpen(false);
                }}
              >
                <span className="text-white-btn my-0">{t("Common.no")}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export const DeleteUserModal = ({ open, setOpen, onClick}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const configData = useSelector((state) => state.config.data);

  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-content-bg h-100">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
            />
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span className="my-2 fs-20">{t("Profile.conformDeleteMsg")}</span>
            {/* <br /><br /> */}
            <div className="d-flex flex-wrap justify-content-center mt-2 mt-md-3 mt-lg-4 mt-xl-4 mb-2">
              <button
                type="submit"
                className={`
             btn-red btn-red-shadow px-3 px-md-5 py-2 mx-2 btn fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                  onClick();
                }}
              >
                <span className="text-white-btn my-0">{t("Common.yes")}</span>
              </button>
              <button
                type="submit"
                className={`
             btn-purple btn-purple-shadow px-3 px-md-5 py-2 btn mx-2 fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                  setOpen(false);
                }}
              >
                <span className="text-white-btn my-0">{t("Common.no")}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const GameModel = ({ open, setOpen }) => {
  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ minWidth: "90%", maxHeight: "80vh", height: "100%" }}
      >
        <div className="modal-content modal-content-bg h-100">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span
                className="svg-icon svg-icon-1"
                onClick={() => {
                  setOpen(!open);
                }}
              >
                <img src={Cross} className="svg-icon" />
              </span>
            </div>
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            {/* <ReloadIframeTwice /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export const ReloadIframeTwice = () => {
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    // Reload once after 1 second
    const first = setTimeout(() => setReloadKey(1), 1000);

    // Reload again after 3 seconds
    const second = setTimeout(() => setReloadKey(2), 3000);

    return () => {
      clearTimeout(first);
      clearTimeout(second);
    };
  }, []);

  return (
    <iframe
      key={reloadKey}
      src="https://kenof.staging-server.in/"
      title="Iframe Proxy"
      sandbox="allow-scripts allow-same-origin"
      style={{
        border: "none",
        width: "100%",
        height: "100%",
        display: "flex",
        margin: "auto",
      }}
    />
  );
};

export const MaintananceModel = ({ open, setOpen }) => {
  const { t } = useTranslation();
  const configData = useSelector((state) => state.config.data);
  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-content-bg h-100">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
            />
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span className="my-2 fs-20">{t(`Sidebar.maintananceText`)}</span>

            <div className="d-flex flex-wrap justify-content-center mt-2 mt-md-3 mt-lg-4 mt-xl-4 mb-2">
              <button
                type="submit"
                className={`
           btn-red btn-red-shadow px-3 px-md-5 py-2 mx-2 btn fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                <span className="text-white-btn my-0">{t("Mission.ok")}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ShareModal = ({ refercode, open, setOpen }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const [code, setCode] = useState("");
  const url = process.env.REACT_APP_FRONT_URL

  const shareUrl = `${url}/signup?refercode=${refercode}`;
  const title = "Check out this awesome site!";
  const configData = useSelector((state) => state.config.data);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // reset after 2 sec
      setOpen(!open);
    } catch (err) {
      console.error("Failed to copy!", err);
      setOpen(!open);
    }
  };

  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-content-bg">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
            />
            <span
              className="svg-icon svg-icon-1 cursor-pointer"
              onClick={() => {
                setOpen(!open);
              }}
            >
              <img
                src={Cross}
                className="svg-icon"
                style={{ position: "absolute", right: "10px", top: "10px" }}
              />
            </span>
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
            <span className="my-2 fs-20">{t("ReferralEarning.subTitle")}</span>
            {/* <br /><br /> */}
            <div className="d-flex text-center m-auto my-2">
              <div className="p-2 m-1 social-logo rounded-2 cursor-pointer">
                <FacebookShareButton url={shareUrl} quote={title}>
                  <FacebookIcon size={30} round iconFillColor="white" />
                </FacebookShareButton>
              </div>

              <div className="p-2 m-1 social-logo rounded-2 cursor-pointer">
                <TwitterShareButton url={shareUrl} quote={title}>
                  {/* <img src={Twitter} /> */}
                  <TwitterIcon size={30} round iconFillColor="white" />
                </TwitterShareButton>
              </div>
              <div className="p-2 m-1 social-logo rounded-2 cursor-pointer">
                <WhatsappShareButton
                  url={shareUrl}
                  quote={title}
                  className="white-icon"
                >
                  <WhatsappIcon
                    size={30}
                    round
                    iconFillColor="white"
                    color="white"
                  />
                </WhatsappShareButton>
              </div>
              <div className="p-2 m-1 social-logo rounded-2 cursor-pointer">
                <ThreadsShareButton
                  url={shareUrl}
                  quote={title}
                  className="white-icon"
                >
                  <ThreadsIcon
                    size={30}
                    round
                    iconFillColor="white"
                    color="white"
                  />
                </ThreadsShareButton>
              </div>
            </div>

            <div className=" d-block  w-auto">
              <input
                type="text"
                className=" fs-14 form-control w-100 bg-grey border-0 text-white"
                value={shareUrl}
                disabled={true}
                onChange={(e) => {
                  e.preventDefault();
                }}
              />

              <button
                type="submit"
                className={` d-flex m-auto my-2 btn-purple btn-purple-shadow px-4 py-2 btn fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                  handleCopy();
                }}
              >
                <span className="text-white-btn my-0">{t("ReferralEarning.copyLink")}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const InactiveModal = ({ open, setOpen }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
 
  const configData = useSelector((state) => state.config.data);

  const handleLogout = () => {
    deleteCookies("xcasino_token");
    dispatch({ type: "RESET_STATE" });
    setOpen(false);

    persistor.purge();

    sessionStorage.clear();
    localStorage.clear();
    window.location.reload("/");
  };

  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-content-bg h-100">
          <div className="modal-header py-1 py-md-2 justify-content-center">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
            />
           
          </div>

          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-2">
          
            <span className="my-2 fs-20">{t('Sidebar.inactive')}</span>
            {/* <br /><br /> */}
            <div className="d-flex flex-wrap justify-content-center mt-2 mt-md-3 mt-lg-4 mt-xl-4 mb-2">
              <button
                type="submit"
                className={`
             btn-red btn-red-shadow px-3 px-md-5 py-2 mx-2 btn fw-semibold`}
                onClick={(e) => {
                  e.preventDefault();
                  handleLogout();
                }}
              >
                <span className="text-white-btn my-0">{t("Mission.ok")}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ImageModal = ({ open, setOpen, imgUrl }) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(true);
  const configData = useSelector((state) => state.config.data);

  return (
    <div className={open ? `modal d-block` : `modal`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-content-bg">
          <div className="modal-header py-1 py-md-2 justify-content-end">
            {/* <span className=" text-light-purple fs-24 text-center">
              {t(`Mission.missionAchieved`)}
            </span> */}

            {/* <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="w-27 pt-2"
              style={{ maxHeight: "50px", width: "auto" }}
            /> */}
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span
                className="svg-icon svg-icon-1"
                onClick={() => {
                  setOpen(!open);
                }}
              >
                <img src={Cross} className="svg-icon" />
              </span>
            </div>
          </div>

          <div className="modal-body  text-center text-white fw-semibold scroll-y m-3">
          
          <img src={imgUrl} className="svg-icon" width={"100%"} height={"100%"} />
          
           
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
